import React from 'react';
import { Button, CircularProgress, IconButton, styled } from '@mui/material';
import { FileDownloadOutlined } from '@mui/icons-material';

// Na barra do app (celular) só o ícone; no cabeçalho da página (desktop) o botão com texto.
const MobileOnly = styled('div')(({ theme }) => ({
  display: 'none',
  [theme.breakpoints.down('sm')]: {
    display: 'flex',
  },
}));

interface ReportGuideExportButtonProps {
  onClick(): void;
  loading: boolean;
  compact?: boolean;
}

const ReportGuideExportButton: React.FC<ReportGuideExportButtonProps> = ({ onClick, loading, compact = false }) => {
  if (compact) {
    return (
      <MobileOnly>
        <IconButton color="inherit" onClick={onClick} disabled={loading} aria-label="Exportar para Excel">
          {loading ? <CircularProgress size={20} color="inherit" /> : <FileDownloadOutlined />}
        </IconButton>
      </MobileOnly>
    );
  }

  return (
    <Button
      variant="outlined"
      size="small"
      onClick={onClick}
      disabled={loading}
      startIcon={loading ? <CircularProgress size={16} /> : <FileDownloadOutlined />}
    >
      Exportar Excel
    </Button>
  );
};

export default ReportGuideExportButton;
